import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { generatePath, Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PracticeData } from 'shell/models/practice';

interface NewPracticeProps {
  tipoPratica: string;
  ForAnagrafeTemporanea?: boolean;
  //questo prop viene utilizzato per reindirizzare l'utene alla pagina di modifica per le pratica di anagrafe temporanea
}

const NewPracticeComponent = ({
  tipoPratica,
  ForAnagrafeTemporanea,
}: NewPracticeProps): React.ReactElement => {
  const [newPratica] = useHttpFetch<HttpResponse<PracticeData>, PracticeData>(
    `${__PRACTICE_API_URL__}/pratiche/creazione/bozza`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          tipoPratica,
        },
      },
      transformer: (response: AxiosResponse<HttpResponse<PracticeData>>) => {
        return response.data.payload as PracticeData;
      },
    }
  );

  if (newPratica.isLoading && !newPratica.data) {
    // in attesa di dati

    return <></>;
  }

  const dataKey = (newPratica.data as PracticeData)?.key;

  if (newPratica.hasErrors && !newPratica.isLoading) {
    // per errore
    toast.error('Errore nella creazione');

    return <Navigate to={{ pathname: '/pratiche' }} />;
  }

  if (
    dataKey?.codiceEnte &&
    dataKey?.tipoRegistro &&
    dataKey?.idAnnoPratica?.toString() &&
    dataKey?.progressivoPratica?.toString() &&
    (newPratica.data as PracticeData)?.tipoPratica
  ) {
    return (
      <>
        {ForAnagrafeTemporanea ? (
          <Navigate
            to={{
              pathname: generatePath(
                '/pratiche/ricerca/modifica/anagrafe-temporanea/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica',
                {
                  codiceEnte: dataKey?.codiceEnte || '',
                  tipoRegistro: dataKey?.tipoRegistro || '',
                  idAnnoPratica: dataKey?.idAnnoPratica?.toString() || '',
                  progressivoPratica: dataKey?.progressivoPratica?.toString() || '',
                  tipoPratica: (newPratica.data as PracticeData)?.tipoPratica || '',
                }
              ),
            }}
          />
        ) : (
          <Navigate
            to={{
              pathname: generatePath(
                '/pratiche/ricerca/modifica/:codiceEnte/:tipoRegistro/:idAnnoPratica/:progressivoPratica/:tipoPratica',
                {
                  codiceEnte: dataKey?.codiceEnte || '',
                  tipoRegistro: dataKey?.tipoRegistro || '',
                  idAnnoPratica: dataKey?.idAnnoPratica?.toString() || '',
                  progressivoPratica: dataKey?.progressivoPratica?.toString() || '',
                  tipoPratica: (newPratica.data as PracticeData)?.tipoPratica || '',
                }
              ),
            }}
          />
        )}
      </>
    );
  }

  return <></>;
};

NewPracticeComponent.displayName = 'NewPractice component';

const NewPractice = memo(NewPracticeComponent);

export default NewPractice as typeof NewPracticeComponent;
